import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";
import { formatRupiah } from "component/utils/formatRupiah";

const ItemForm = ({ mode, itemData, categoryData, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    title: "",
    price: "",
    country: "",
    city: "",
    category_id: "",
    image: "",
    description: "",
  });

  useEffect(() => {
    if (mode === "edit" && itemData) {
      setFormData(itemData);
    } else {
      setFormData({
        title: "",
        price: "",
        country: "",
        city: "",
        category_id: "",
        image: "",
        description: "",
      });
    }
  },[mode,itemData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "price") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData({
        ...formData,
        [name]: formatRupiah(numericValue),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({
      ...formData,
      image: files,
    });
  };  

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === "add") {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("price", formData.price.replace(/[^0-9]/g, ""));
        data.append("country", formData.country);
        data.append("city", formData.city);
        data.append("category_id", formData.category_id);
        data.append("description", formData.description);

        formData.image.forEach((file) => {
          data.append("image", file);
        });

        const response = await axios.post(
          `${process.env.REACT_APP_API}/item`,
          data,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
  
        if (response.status === 201) {
          showSuccess("Item berhasil ditambahkan");
          closeModal();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal menambahkan Item");
        }

      } else {
        const updatedForm = new FormData();
        updatedForm.append("item_id", formData.item_id);
        updatedForm.append("title", formData.title);
        updatedForm.append("price", formData.price.replace(/[^0-9]/g, ""));
        updatedForm.append("country", formData.country);
        updatedForm.append("city", formData.city);
        updatedForm.append("category_id", formData.category_id);
        updatedForm.append("description", formData.description);

        if (formData.image && formData.image.length > 0) {
          updatedForm.append("image_url", formData.image_url);
          formData.image.forEach((file) => {
            updatedForm.append("image", file);
          });
        }

        // for (let pair of updatedForm.entries()) {
        //   console.log(pair[0] + ':', pair[1]);
        // }
  
        const response = await axios.put(
          `${process.env.REACT_APP_API}/item/${formData.item_id}`,
          updatedForm,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
  
        if (response.status === 200) {
          showSuccess("Item berhasil diperbarui");
          closeModal();
          if (onSuccess) onSuccess();
        } else {
          showError("Gagal memperbarui Item");
        }
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
    }
  };

  return (        
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah Item" : "Edit Item"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="form-group mb-3">
            <label htmlFor="category_id" className="form-label">Pilih Kategori</label>
            {mode === "edit" ? (
              // Mode Edit: Tidak menampilkan "Pilih Kategori", langsung opsi kategori yang sesuai
              <select
                className="form-select"
                name="category_id"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value={formData.category_id}>
                  {
                    categoryData.find(cat => cat.category_id === formData.category_id)?.name || "Kategori Terpilih"
                  }
                </option>
                {categoryData.map(cat => (
                  cat.category_id !== formData.category_id && (
                    <option key={cat.category_id} value={cat.category_id}>
                      {cat.name}
                    </option>
                  )
                ))}
              </select>
            ) : (
              <select
                className="form-select"
                name="category_id"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="" hidden>--- Pilih Kategori ---</option>
                {categoryData.map(cat => (
                  <option key={cat.category_id} value={cat.category_id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div class="form-group mb-3">
            <label for="title" class="form-label">Nama Item</label>
            <input 
              class="form-control"
              type="text" 
              name="title"
              placeholder="Isi Nama Item"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>
          <div class="form-group mb-3">
            <label for="price" class="form-label">Price</label>
            <input 
              class="form-control"
              type="text" 
              name="price"
              placeholder="Isi Price"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>
          {/* <div class="form-group mb-3">
            <label for="country" class="form-label">Country</label>
            <input 
              class="form-control"
              type="text" 
              name="country"
              placeholder="Isi Country"
              value={formData.country}
              onChange={handleChange}
              required
            />
          </div> */}
          <div class="form-group mb-4">
            <label for="city" class="form-label">City</label>
            <input 
              class="form-control"
              type="text" 
              name="city"
              placeholder="Isi City"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>
          <div class="form-group mb-4">
            <label for="image" class="form-label">Image</label>
            <input
              type="file"
              className="form-control"
              id="image"
              name="image"
              onChange={handleFileChange}
              multiple
              required={mode === "add"}
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="description" className="form-label">Deskripsi</label>
            <textarea
              className="form-control"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="4"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary">
            {mode === "add" ? "Save" : "Update"}
          </button>
        </form>

        </div>
      </div>
    </div>
  );
};

export default ItemForm;
